<template>
  <div class="page">
    <div class="left">
      <div class="swiper_content">
        <div class="swiper-box">
          <swiper
            :modules="modules"
            :slides-per-view="1"
            :space-between="0"
            :navigation="navigation"
          >
            <swiper-slide v-for="item in list" :key="item.id">
              <div class="slider-item" @click="openDetail(item.url)">
                <img class="img" :src="item.url" />
              </div>
            </swiper-slide>
          </swiper>
          <img
            src="@/assets/images/svg/back.svg"
            class="swiper-button-prev img-btn arr_left"
            alt=""
          />
          <img
            src="@/assets/images/svg/back.svg"
            class="swiper-button-next img-btn arr_right rotate180"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="content_right">
      <div class="item">
        <div class="left1">
          <div class="first">White</div>
          <div class="second">￥：100</div>
        </div>
        <div class="right">
          <div class="top">
            <div class="avatr"></div>
            <div class="avatr_1">作者：</div>
            <div class="avatr_2">用户123@Aa</div>
          </div>
          <div class="down">道具简介xmciudcnjaciudcia</div>
        </div>
      </div>

      <div class="vchat">
        <img src="@/assets/images/Rectangle 487.png" alt="" />
      </div>
      <div class="buy">BUY NOW</div>
    </div>
    <div class="back" @click="closeMask">
      <img src="@/assets/images/svg/back.svg" alt="" />
    </div>
  </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { ref } from "vue";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css/pagination"; // 导入 Pagination 样式
import "swiper/css";

const navigation = ref({
  nextEl: ".swiper-button-next",
  prevEl: ".swiper-button-prev",
});
const modules = [Navigation, Pagination];
const list =
  ref <
  {
    id: undefined,
    url: "",
  } >
  [
    {
      id: 2,
      url: "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/shadow.png",
    },
    {
      id: 3,
      url: "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/Tetris2.png",
    },
    {
      id: 5,
      url: "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/image/game/shadow.png",
    },
  ];

const chooseUrl = ref(list.value[0].url);
// const count = ref(1);

const openDetail = (url) => {
  chooseUrl.value = url;
};
// const props = defineProps({
//   close: {},
// });
// const { close } = props;
// const closeMask = () => {
//   close();
// };
</script>
<style lang="scss" scoped>
.page {
  z-index: 1999; /* 确保遮罩在其他内容之上 */
  background: var(--ux-card-bg);
  display: flex;
  height: 651px;
  width: 100%;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
  // padding: 0 238px;
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 55%;
    border-right: 1px solid var(--ux-text-primary);
    .swiper_content {
      display: flex;
      justify-content: center;
      .swiper-box {
        width: 762px;
        position: relative;
        margin: auto;
        .slider-item {
          width: 762px;
          height: 464px;
          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
          border-radius: 0px 0px 0px 0px;
        }
        .img {
          width: 100%;
          &:hover {
            cursor: pointer;
          }
        }
        .arr_left {
          left: -49.994px;
        }
        .arr_right {
          right: -49.994px;
        }
      }
    }
    .detail_show {
      margin-left: -100.002px;
      img {
        width: 532px;
        height: 532px;
      }
    }
  }
  .content_right {
    height: 100vh;
    margin-left: 74px;
    margin-top: 77px;
    flex: 1;
    .item {
      display: flex;
      .left1 {
        font-family: MicrosoftYaHei UI, Microsoft YaHei UI;
        font-weight: bold;
        font-size: 39.998px;
        color: var(--ux-text-primary);
        line-height: 46.998px;
        text-transform: none;
        margin-right: 28px;
        .first {
          margin-bottom: 14px;
        }
      }

      .right {
        .top {
          display: flex;
          align-items: center;
          margin-bottom: 14px;
          .avatr {
            width: 44.002px;
            height: 44.002px;
            background: var(--ux-surface-muted);
            border-radius: 50%;
            margin-right: 14px;
          }
          .avatr_1 {
            font-family: MicrosoftYaHei UI, Microsoft YaHei UI;
            font-weight: 400;
            font-size: 16.002px;
            color: var(--ux-text-primary);
            line-height: 18.998px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
          .avatr_2 {
            font-family: MicrosoftYaHei UI, Microsoft YaHei UI;
            font-weight: 400;
            font-size: 16.002px;
            color: var(--ux-text-primary);
            line-height: 18.998px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }
    }
    .vchat {
      margin-top: 42px;
      img {
        width: 387px;
        height: 232px;
      }
    }
    .buy {
      width: 207.004px;
      height: 65.002px;
      background: var(--ux-card-bg);
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #000;
      font-family: MicrosoftYaHei UI, Microsoft YaHei UI;
      font-weight: 400;
      font-size: 20.006px;
      color: var(--ux-text-primary);
      line-height: 65.002px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
      margin-top: 28px;
    }
  }
  .back {
    position: absolute;
    right: 28px;
    top: 28px;
    width: 48.006px;
    &:hover {
      cursor: pointer;
    }
  }
  .rotate180 {
    transform: rotate(180deg);
  }
}
</style>
